module.exports = __webpack_public_path__ + "img/oragenics.0b50108b.svg";